import React, {useEffect, useState} from 'react';

import {PopupPostBlock, NewPostBlock, LoadMoreBlock, Section} from './Blocks.js';
import {guestbook, QueryPost} from './Functions.js';

const List=()=>{

	const [posts, SetPosts]=useState([]);
	const [intLoading, SetLoading]=useState(false);
	const [intPage, SetPage]=useState(1);
	const [intLoadMore, SetLoadMore]=useState(true);
	const [intPostID, SetPostID]=useState(0);

	const [open, SetOpen]=useState(false);

	useEffect(()=>{

		SetLoading(true);

		if(intPage>1){
			/*
			SetPosts((prev)=>{
				prev.push({id:0, post:''});
				return prev;
			});
			*/
			SetPosts((prev)=>[...prev, {id:0, post:''}]);
		}

		QueryPost(intPage)

			.then(res=>{
				if(res.success){
					return res.data;
				}
			}).then((res)=>{

				SetPosts((prev)=>{

					if(intPage>1){
						prev.pop();
						if(res.posts.length>0){
							guestbook['new-id']=res.posts[0].id;
						}
					}

					if(res.posts.length===0||prev.some(item=>item.id===res.posts[0].id)){ // https://stackoverflow.com/questions/237104/how-do-i-check-if-an-array-includes-a-value-in-javascript
						if(res.posts.length===0)SetLoadMore(false);
						return prev;
					}

					if(intPage>1&&res.posts.length<res.size){
						SetLoadMore(false);
						if(res.posts.length===0){
							return prev;
						}
					}

					return [...prev, ...res.posts];

				});
				// SetErrorMessage('');
		}).catch(error=>{
			// SetErrorMessage('Something went wrong, Please try again later');

		}).finally(()=>{
			SetLoading(false);
			guestbook.loaded=true;
		});

	}, [intPage]);

	useEffect(()=>{
		// console.log(1, posts);
	}, [posts]);

	useEffect(()=>{
		// console.log(2, open);
	}, [open]);

	useEffect(()=>{ // 所有在啟動 intLoading 後該執行的

		if(guestbook['new-id']>0&&guestbook.loaded===true){
			document.getElementById('post-'+guestbook['new-id']).scrollIntoView({behavior:'smooth'});
			guestbook.loaded=false;

		}else{
			if(intPage>1&&intLoading){
				document.getElementById('load-more').scrollIntoView({behavior:'smooth'});
			}
		}

	});

	if(posts.length===0){
		return (
			<Section
				type="post"
				item={{id:0, post:''}}
				/>
		);
	}

	return (
		<>
			<NewPostBlock
				SetOpen={SetOpen}
				/>
			{posts.map((item)=>(
				<Section
					item={item}
					key={'posts-'+item.id}
					type="post"
					SetOpen={SetOpen}
					SetPostID={SetPostID}
					SetPosts={SetPosts}
					posts={posts}
					/>
			))}
			{
				intLoadMore
				&&
				<LoadMoreBlock {...{SetPage, intLoading}} />
			}
			{
				(guestbook['post-id']>0||guestbook['post-id']==='new')
				&&
				<PopupPostBlock
					{...{SetOpen, SetPosts, SetPostID, intPostID, open, posts}}
					/>
			}
		</>
	);

}

export default List;